export const ACTIVE_TENANT_STORAGE_KEY = "stero.activeTenantId";
export const ACTIVE_TENANT_ORG_STORAGE_KEY = "stero.activeTenantOrgId";
export const ACTIVE_TENANT_CONTEXT_CHANGED_EVENT = "stero:active-tenant-context-changed";

export function emitActiveTenantContextChanged(): void {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }

  const EventCtor = typeof window.CustomEvent === "function" ? window.CustomEvent : window.Event;
  window.dispatchEvent(new EventCtor(ACTIVE_TENANT_CONTEXT_CHANGED_EVENT));
}

export function subscribeActiveTenantContextChanged(listener: () => void): () => void {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") {
    return () => {};
  }

  const handleContextChanged = () => listener();
  const handleStorage = (event: StorageEvent) => {
    if (event.key === ACTIVE_TENANT_STORAGE_KEY || event.key === ACTIVE_TENANT_ORG_STORAGE_KEY) {
      listener();
    }
  };

  window.addEventListener(ACTIVE_TENANT_CONTEXT_CHANGED_EVENT, handleContextChanged);
  window.addEventListener("storage", handleStorage);

  return () => {
    window.removeEventListener(ACTIVE_TENANT_CONTEXT_CHANGED_EVENT, handleContextChanged);
    window.removeEventListener("storage", handleStorage);
  };
}
